<template>
	<div class="content-wrapper">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item">
					<a href="#">
						<i class="fa fa-home"></i>
						Dashboard
					</a>
				</li>
				<li class="breadcrumb-item active">Affiliate Transaction Report</li>
			</ol>
		</nav>
		<section class="content">
			<div class="container-fluid">
				<div class="row justify-content-md-center">
					<!-- Customers Table Card -->
					<div class="col-sm-12">
						<div class="card">
							<div class="card-header">
								<h3 class="card-title">
									<i class="fas fa-users mr-2"></i>Affiliate Customers
								</h3>
								<div class="card-tools">
									<button v-if="selectedAffiliateId" @click="exportCustomers"
										class="btn btn-sm btn-outline-success">
										<i class="fa fa-download"></i> Export Customers
									</button>
								</div>
							</div>
							<div class="card-body">
								<div class="row mb-3">
									<div class="col-md-3">
										<div class="form-group">
											<label>Select Affiliate</label>
											<select class="form-control form-control-sm" v-model="selectedAffiliateId"
												@change="onAffiliateChange">
												<option value="">Select Affiliate</option>
												<option v-for="affiliate in affiliates" :key="affiliate.customer_id"
													:value="affiliate.customer_id">
													{{ affiliate.customer_no }} - {{ affiliate.customer_name }}
												</option>
											</select>
										</div>
									</div>
									<div class="col-md-3">
										<div class="form-group">
											<label>Select Branch</label>
											<select class="form-control form-control-sm" v-model="selectedBranchId"
												@change="onBranchChange" :disabled="!selectedAffiliateId">
												<option value="">Select Branch</option>
												<option v-for="branch in branches" :key="branch.branch_id"
													:value="branch.branch_id">
													{{ branch.branch_name }}
												</option>
											</select>
										</div>
									</div>
									<div class="col-md-3">
										<div class="form-group">
											<label>Select Session</label>
											<select class="form-control form-control-sm" v-model="selectedSessionId"
												@change="onSessionChange"
												:disabled="!selectedAffiliateId || !selectedBranchId">
												<option value="">All Sessions</option>
												<option v-for="session in filteredSessionLogs"
													:key="session.session_log_id" :value="session.session_log_id">
													{{ session.display }}
												</option>
											</select>
										</div>
									</div>
									<div class="col-md-3">
										<div class="form-group">
											<label>&nbsp;</label>
											<input class="form-control form-control-sm" type="text" placeholder="Search"
												v-model="meta.search" @keyup="search"
												:disabled="!selectedAffiliateId" />
										</div>
									</div>
								</div>

								<div class="table-responsive">
									<table class="table table-bordered text-nowrap table-striped table-sm">
										<thead>
											<tr>
												<th class="text-center">#</th>
												<th class="text-center" @click="sort('customer_name')">
													Customer
													<span>
														<i v-if="
															meta.keyword == 'customer_name' &&
															meta.order_by == 'asc'
														" class="fas fa-sort-up"></i>
														<i v-else-if="
															meta.keyword == 'customer_name' &&
															meta.order_by == 'desc'
														" class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-center" @click="sort('mobile_no')">
													Mobile No
													<span>
														<i v-if="
															meta.keyword == 'mobile_no' &&
															meta.order_by == 'asc'
														" class="fas fa-sort-up"></i>
														<i v-else-if="
															meta.keyword == 'mobile_no' &&
															meta.order_by == 'desc'
														" class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-center" @click="sort('customer_credit_limit')">
													Credit Limit
													<span>
														<i v-if="
															meta.keyword == 'customer_credit_limit' &&
															meta.order_by == 'asc'
														" class="fas fa-sort-up"></i>
														<i v-else-if="
															meta.keyword == 'customer_credit_limit' &&
															meta.order_by == 'desc'
														" class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-center" @click="sort('total_deposit')">
													Total Deposit
													<span>
														<i v-if="meta.keyword == 'total_deposit' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'total_deposit' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-center" @click="sort('total_buyin')">
													Total BuyIn
													<span>
														<i v-if="meta.keyword == 'total_buyin' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'total_buyin' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-center" @click="sort('total_cashout')">
													Total CashOut
													<span>
														<i v-if="meta.keyword == 'total_cashout' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'total_cashout' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-center" @click="sort('total_withdraw')">
													Total Withdraw
													<span>
														<i v-if="meta.keyword == 'total_withdraw' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'total_withdraw' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-center" @click="sort('total_tds')">
													Total TDS
													<span>
														<i v-if="meta.keyword == 'total_tds' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'total_tds' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
												<th class="text-center" @click="sort('wallet_balance')">
													Wallet Balance
													<span>
														<i v-if="meta.keyword == 'wallet_balance' && meta.order_by == 'asc'"
															class="fas fa-sort-up"></i>
														<i v-else-if="meta.keyword == 'wallet_balance' && meta.order_by == 'desc'"
															class="fas fa-sort-down"></i>
														<i v-else class="fas fa-sort"></i>
													</span>
												</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(customer, key) in customers" :key="key">
												<td class="text-center">{{ meta.from + key }}</td>
												<td class="text-center customer-link" style="cursor: pointer;"
													@click="openCustomerTransactions(customer)">
													<div>{{ customer.customer_name }}</div>
													<div class="text-muted small">{{ customer.customer_no }}</div>
												</td>
												<td class="text-center">
													<a :href="`https://wa.me/${customer.country_code || '+91'}${customer.mobile_no}`"
														target="_blank" rel="noopener noreferrer">
														{{ customer.mobile_no }}
													</a>
												</td>
												<td class="text-center">
													<b>{{ $formatCurrency(customer.affiliate_customer_credit_limit)
														|| 'Not Set' }}</b>
												</td>
												<td class="text-center">
													{{ $formatCurrency(customer.total_deposit || 0) }}
												</td>
												<td class="text-center">
													{{ $formatCurrency(customer.total_buyin || 0) }}
												</td>
												<td class="text-center">
													{{ $formatCurrency(customer.total_cashout || 0) }}
												</td>
												<td class="text-center">
													{{ $formatCurrency(customer.total_withdraw || 0) }}
												</td>
												<td class="text-center">
													{{ $formatCurrency(customer.total_tds || 0) }}
												</td>
												<td class="text-center">
													<b>{{ $formatCurrency(customer.wallet_balance || 0) }}</b>
												</td>
											</tr>
											<tr v-if="customers.length <= 0">
												<td colspan="10" style="text-align: center">
													No Records Found
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
							<div class="card-footer">
								<div class="float-right">
									<Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage"
										:currentPage="meta.page" @pagechanged="onPageChange" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<!-- Customer Transactions Modal -->
		<div ref="customerTransactionsModal" class="modal fade" tabindex="-1" role="dialog"
			aria-labelledby="customerTransactionsModalLabel" aria-hidden="true">
			<div class="modal-dialog modal-xl" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="customerTransactionsModalLabel">
							Transactions - {{ selectedCustomerForTransactions?.customer_name }}
							<span v-if="selectedCustomerForTransactions" class="text-muted small">({{
								selectedCustomerForTransactions.customer_no }})</span>
						</h5>
						<div class="ml-auto mr-3">
							<button v-if="selectedCustomerForTransactions && selectedAffiliateId"
								@click="exportTransactions" class="btn btn-sm btn-outline-success">
								<i class="fa fa-download"></i> Export Transactions
							</button>
						</div>
						<button type="button" class="close" @click="closeCustomerTransactionsModal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<div class="table-responsive">
							<table class="table table-bordered table-striped table-sm text-nowrap">
								<thead>
									<tr>
										<th class="text-center">#</th>
										<th>T. No</th>
										<th>T. Date-Time</th>
										<th>T. Type</th>
										<th class="text-right">Amount</th>
										<th class="text-center">Status</th>
									</tr>
								</thead>
								<tbody>
									<tr v-for="(tx, idx) in customerTransactions" :key="idx">
										<td class="text-center">{{ customerTxMeta.from + idx }}</td>
										<td>{{ tx.transaction_no }}</td>
										<td>{{ $formatDate(tx.transaction_date_time, 'india') }}</td>
										<td>{{ tx.transaction_type }}</td>
										<td class="text-right">{{ $formatCurrency(tx.amount) }}</td>
										<td class="text-center">
											<span v-if="tx.status == 'Pending'"
												class="badge badge-warning">Pending</span>
											<span v-else-if="tx.status == 'Approved'"
												class="badge badge-success">Approved</span>
											<span v-else-if="tx.status == 'Rejected'"
												class="badge badge-danger">Rejected</span>
											<span v-else class="badge badge-secondary">{{ tx.status }}</span>
										</td>
									</tr>
									<tr v-if="customerTransactions.length <= 0">
										<td colspan="6" class="text-center">No Records Found</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<div class="modal-footer">
						<div class="ml-auto d-flex align-items-center">
							<Pagination :maxPage="customerTxMeta.maxPage" :totalPages="customerTxMeta.lastPage"
								:currentPage="customerTxMeta.page" @pagechanged="onCustomerTxPageChange" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Pagination from "@/components/Pagination.vue";
import axios from "axios";
export default {
	name: "AffiliateTransactionReport",
	components: { Pagination },
	data() {
		return {
			meta: {
				search: "",
				order_by: "desc",
				keyword: "customer_credit_limit",
				per_page: 50,
				totalRows: 0,
				page: 1,
				lastPage: 1,
				from: 1,
				maxPage: 1,
			},
			customers: [],
			errors: [],
			affiliates: [],
			selectedAffiliateId: "",
			branches: [],
			selectedBranchId: "",
			sessionLogs: [],
			selectedSessionId: "",
			userSelectedAllSessions: false, // Track if user explicitly selected "All Sessions"
			// Customer transactions modal state
			selectedCustomerForTransactions: null,
			customerTransactions: [],
			customerTxMeta: {
				customer_id: "",
				affiliate_id: "",
				session_log_id: "",
				branch_id: "",
				order_by: "desc",
				keyword: "transaction_id",
				per_page: 50,
				totalRows: 0,
				page: 1,
				lastPage: 1,
				from: 1,
				maxPage: 1,
				search: "",
			},
			customerTxErrors: [],
		};
	},

	computed: {
		filteredSessionLogs() {
			if (!this.selectedBranchId) {
				return [];
			}
			return this.sessionLogs.filter(session => session.branch_id == this.selectedBranchId);
		}
	},

	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.loadAffiliates();
			vm.loadBranches();
		});
	},

	methods: {
		loadAffiliates() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "getAffiliates", data: {} })
				.then(function (response) {
					vm.affiliates = response.data.data || [];
				})
				.catch(function (error) {
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to load affiliates");
				});
		},

		loadBranches() {
			let vm = this;
			vm.$store
				.dispatch("post", { uri: "getBranches", data: {} })
				.then(function (response) {
					vm.branches = response.data.data || [];
				})
				.catch(function (error) {
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to load branches");
				});
		},

		loadSessionLogs() {
			let vm = this;
			if (!vm.selectedAffiliateId) {
				return;
			}
			vm.$store
				.dispatch("post", {
					uri: "getAffiliateSessionLogs",
					data: { affiliate_id: vm.selectedAffiliateId }
				})
				.then(function (response) {
					vm.sessionLogs = response.data.data || [];
					vm.updateSelectedSession();
				})
				.catch(function (error) {
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to load session logs");
				});
		},

		updateSelectedSession() {
			let vm = this;
			// Auto-select first session if available and user hasn't explicitly chosen "All Sessions"
			if (vm.filteredSessionLogs.length > 0 && !vm.selectedSessionId && !vm.userSelectedAllSessions) {
				vm.selectedSessionId = vm.filteredSessionLogs[0].session_log_id;
			}
			vm.index();
		},

		onAffiliateChange() {
			this.selectedBranchId = "";
			this.selectedSessionId = "";
			this.userSelectedAllSessions = false;
			this.sessionLogs = [];
			this.customers = [];
			if (this.selectedAffiliateId) {
				this.loadSessionLogs();
			}
		},

		onBranchChange() {
			// If user had a specific session selected, try to keep it if it exists in new branch
			// Otherwise, allow "All Sessions" or auto-select first session
			const currentSessionId = this.selectedSessionId;
			const sessionExists = this.filteredSessionLogs.some(s => s.session_log_id == currentSessionId);

			if (!sessionExists) {
				// Clear selection if session doesn't exist in new branch
				// Reset the flag so we can auto-select if needed
				this.selectedSessionId = "";
				this.userSelectedAllSessions = false;
			}
			this.updateSelectedSession();
		},

		onSessionChange() {
			// Track if user explicitly selected "All Sessions"
			this.userSelectedAllSessions = !this.selectedSessionId;
			this.meta.page = 1;
			this.index();
		},

		search() {
			let vm = this;
			vm.meta.page = 1;
			vm.index();
		},

		sort(field) {
			this.meta.keyword = field;
			this.meta.order_by = this.meta.order_by == "asc" ? "desc" : "asc";
			this.index();
		},

		index() {
			let vm = this;
			if (!vm.selectedAffiliateId) {
				return;
			}

			let uri = "getAffiliateCustomersBySession";
			let data = { ...vm.meta };
			data.affiliate_id = vm.selectedAffiliateId;
			// Only include session_log_id if a session is selected
			if (vm.selectedSessionId) {
				data.session_log_id = vm.selectedSessionId;
			}
			// Include branch_id if selected
			if (vm.selectedBranchId) {
				data.branch_id = vm.selectedBranchId;
			}

			vm.$store
				.dispatch("post", { uri: uri, data: data })
				.then(function (response) {
					vm.customers = response.data.data;
					vm.meta.totalRows = response.data.meta.total;
					vm.meta.lastPage = response.data.meta.last_page;
					vm.meta.from = response.data.meta.from;
					vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
				})
				.catch(function (error) {
					vm.errors = error.response?.data?.errors || {};
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to load customers");
				});
		},

		onPageChange(page) {
			this.meta.page = page;
			this.index();
		},

		openCustomerTransactions(customer) {
			let vm = this;
			vm.selectedCustomerForTransactions = customer;
			vm.customerTxMeta.customer_id = customer.customer_id;
			vm.customerTxMeta.affiliate_id = vm.selectedAffiliateId;
			vm.customerTxMeta.session_log_id = vm.selectedSessionId || null;
			vm.customerTxMeta.branch_id = vm.selectedBranchId || null;
			vm.customerTxMeta.page = 1;
			vm.loadCustomerTransactions();

			if (vm.$refs.customerTransactionsModal) {
				const modalElement = vm.$refs.customerTransactionsModal;
				modalElement.classList.add('show');
				modalElement.style.display = 'block';
				modalElement.setAttribute('aria-hidden', 'false');
				document.body.classList.add('modal-open');
				const backdrop = document.createElement('div');
				backdrop.className = 'modal-backdrop fade show';
				backdrop.setAttribute('id', 'customerTransactionsModalBackdrop');
				document.body.appendChild(backdrop);
			}
		},

		closeCustomerTransactionsModal() {
			let vm = this;
			if (vm.$refs.customerTransactionsModal) {
				const modalElement = vm.$refs.customerTransactionsModal;
				modalElement.classList.remove('show');
				modalElement.style.display = 'none';
				modalElement.setAttribute('aria-hidden', 'true');
				document.body.classList.remove('modal-open');
				const backdrop = document.getElementById('customerTransactionsModalBackdrop');
				if (backdrop) {
					backdrop.remove();
				}
			}
			vm.selectedCustomerForTransactions = null;
			vm.customerTransactions = [];
			vm.customerTxErrors = [];
			vm.customerTxMeta = {
				customer_id: "",
				affiliate_id: "",
				session_log_id: "",
				branch_id: "",
				order_by: "desc",
				keyword: "transaction_id",
				per_page: 50,
				totalRows: 0,
				page: 1,
				lastPage: 1,
				from: 1,
				maxPage: 1,
				search: "",
			};
		},

		loadCustomerTransactions() {
			let vm = this;
			if (!vm.customerTxMeta.customer_id || !vm.customerTxMeta.affiliate_id) {
				return;
			}
			vm.customerTxErrors = [];
			vm.$store
				.dispatch("post", {
					uri: "paginateAffiliateTransactions",
					data: vm.customerTxMeta,
				})
				.then(function (response) {
					vm.customerTransactions = response.data.data;
					vm.customerTxMeta.totalRows = response.data.meta.total;
					vm.customerTxMeta.lastPage = response.data.meta.last_page;
					vm.customerTxMeta.from = response.data.meta.from;
					vm.customerTxMeta.maxPage = vm.customerTxMeta.lastPage >= 3 ? 3 : vm.customerTxMeta.lastPage;
				})
				.catch(function (error) {
					vm.customerTxErrors = error.response?.data?.errors || {};
					vm.$store.dispatch(
						"error",
						error.response?.data?.message || "Failed to load customer transactions"
					);
				});
		},

		onCustomerTxPageChange(page) {
			this.customerTxMeta.page = page;
			this.loadCustomerTransactions();
		},

		exportCustomers() {
			let vm = this;
			if (!vm.selectedAffiliateId) {
				vm.$store.dispatch("error", "Please select affiliate");
				return;
			}

			let loader = vm.$loading.show();
			let data = {
				affiliate_id: vm.selectedAffiliateId,
			};
			// Only include session_log_id if a session is selected
			if (vm.selectedSessionId) {
				data.session_log_id = vm.selectedSessionId;
			}
			// Include branch_id if selected
			if (vm.selectedBranchId) {
				data.branch_id = vm.selectedBranchId;
			}

			// Use axios directly with blob response type
			axios.post(vm.$store.getters.apiUrl + 'exportAffiliateCustomers', data, {
				responseType: 'blob',
				headers: {
					'Authorization': 'Bearer ' + vm.$store.getters.token
				}
			})
				.then(function (response) {
					loader.hide();
					const blob = new Blob([response.data], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
					});
					const url = window.URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = url;
					link.download = 'Affiliate_Customers_' + new Date().toISOString().slice(0, 19).replace(/:/g, '-') + '.xlsx';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					window.URL.revokeObjectURL(url);
					vm.$store.dispatch("success", "Customers exported successfully");
				})
				.catch(function (error) {
					loader.hide();
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to export customers");
				});
		},

		exportTransactions() {
			let vm = this;
			if (!vm.selectedCustomerForTransactions || !vm.selectedAffiliateId) {
				vm.$store.dispatch("error", "Please select a customer");
				return;
			}

			let loader = vm.$loading.show();
			let data = {
				affiliate_id: vm.selectedAffiliateId,
				customer_id: vm.selectedCustomerForTransactions.customer_id,
				session_log_id: vm.selectedSessionId || null,
			};
			// Include branch_id if selected
			if (vm.selectedBranchId) {
				data.branch_id = vm.selectedBranchId;
			}

			// Use axios directly with blob response type
			axios.post(vm.$store.getters.apiUrl + 'exportAffiliateTransactions', data, {
				responseType: 'blob',
				headers: {
					'Authorization': 'Bearer ' + vm.$store.getters.token
				}
			})
				.then(function (response) {
					loader.hide();
					const blob = new Blob([response.data], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
					});
					const url = window.URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = url;
					link.download = 'Affiliate_Transactions_' + new Date().toISOString().slice(0, 19).replace(/:/g, '-') + '.xlsx';
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					window.URL.revokeObjectURL(url);
					vm.$store.dispatch("success", "Transactions exported successfully");
				})
				.catch(function (error) {
					loader.hide();
					vm.$store.dispatch("error", error.response?.data?.message || "Failed to export transactions");
				});
		},
	},
};
</script>
